import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { autoOpen: { type: Boolean, default: false } }

  connect() {
    if (this.element.tagName === 'DIALOG' && !this.element.open && this.autoOpenValue) {
      this.#openModal()
    }
  }

  disconnect() {
    document.body.style.overflow = 'auto'
  }

  open() {
    if (this.element.tagName === 'DIALOG') {
      this.#openModal()
      return
    }
  }

  close() {
    if (this.element.tagName === 'DIALOG') {
      this.element.close()
    }
    document.body.style.overflow = 'auto'

    // Clear the turbo frame
    const frame = document.querySelector('turbo-frame[id="modal"]')
    if (frame) {
      frame.innerHTML = ''
    }
  }

  #openModal() {
    const dialog = this.element
    dialog.showModal()
    document.body.style.overflow = 'hidden'

    // Mobile Chrome/Safari sometimes lay a freshly-shown top-layer <dialog>
    // out against a stale viewport width, so it renders wider than the screen
    // (content spills off the right edge) until the user taps — which triggers
    // a reflow that corrects it. A bare requestAnimationFrame isn't enough; the
    // browser needs an actual layout invalidation. Once the viewport has
    // settled (next frame), toggle a geometric property to force that relayout
    // ourselves, reproducing what the corrective tap does.
    requestAnimationFrame(() => {
      if (!dialog.open) return
      const previousMaxWidth = dialog.style.maxWidth
      dialog.style.maxWidth = '99.99%'
      void dialog.offsetWidth // flush layout at the now-stable viewport width
      dialog.style.maxWidth = previousMaxWidth
    })
  }

  // Close modal when clicking outside
  clickOutside(event) {
    const rect = this.element.getBoundingClientRect()
    const isInDialog = (rect.top <= event.clientY && event.clientY <= rect.top + rect.height &&
      rect.left <= event.clientX && event.clientX <= rect.left + rect.width)

    if (!isInDialog) {
      this.close()
    }
  }
}
